import { embedSearchWidgetRouteGroup } from '#/modules/embedSearchWidget/routing/embedSearchWidget.routes';
import { searchVolopsRouteReference } from '#/modules/search/routing/search.routes';

export const embedSearchWidgetVolopsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('volops');

export const embedSearchWidgetSearchVolopsRoute =
  embedSearchWidgetVolopsRouteGroup.rootRoute(
    searchVolopsRouteReference.searchParams,
  );

export const embedSearchWidgetViewVolopRoute =
  embedSearchWidgetVolopsRouteGroup.route(':volopId');
